import { render, staticRenderFns } from "./MediaNew.vue?vue&type=template&id=dd36012e&"
import script from "./MediaNew.vue?vue&type=script&lang=js&"
export * from "./MediaNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports